import _ from 'lodash';

export default class Form {
    constructor(data) {
        this.fields = data.fields || [];
        this.errors = data.errors || [];
    }

    hasErrors(field = null) {
        if (!field) {
            return _.size(this.errors) > 0;
        }

        return this.errors && _.get(this.errors, field, []).length > 0;
    }

    isRequired(field) {
        return _.get(this.fields, field + '._rules', []).indexOf('required') > -1;
    }

    getErrors(field) {
        return _.get(this, 'errors.' + field, []);
    }

    addError(field, error) {
        let errors = this.getErrors(field);
        errors.push(error);
        this.errors[field] = errors;
    }
}
